import UserUtils, { LOCAL_STORAGE_RECENT_PAGES } from './userUtils';

export interface RecentPage {
    to: string; // pathname (+ search) of the visited page
    title: string;
    subtitle?: string;
    date: number;
}

const MAX_RECENT_PAGES = 8;

// Pages not worth a slot: the palette already lists the menu, and those are one click away
const IGNORED_PATHS = ['/', '/login', '/profil'];

export default class RecentUtils {
    static getRecentPages(): RecentPage[] {
        const pages = UserUtils.getPref(LOCAL_STORAGE_RECENT_PAGES);
        return Array.isArray(pages) ? pages : [];
    }

    /**
     * Record the page currently displayed so the command palette can offer it back.
     * A record title is often filled once its payload is loaded, so pushing the same
     * path twice updates the existing entry instead of stacking a duplicate.
     */
    static pushRecentPage(page: { to: string; title: string; subtitle?: string }): void {
        const { to, title, subtitle } = page;
        if (!to || !title || IGNORED_PATHS.includes(to)) {
            return;
        }

        const pages = RecentUtils.getRecentPages().filter((p) => p.to !== to);
        pages.unshift({ to, title, subtitle, date: Date.now() });
        UserUtils.setPref(LOCAL_STORAGE_RECENT_PAGES, pages.slice(0, MAX_RECENT_PAGES));
    }

    static clearRecentPages(): void {
        UserUtils.removePref(LOCAL_STORAGE_RECENT_PAGES);
    }
}
